import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageIconComponent } from '@svg-icons/page-icon/page-icon.component';
import { SettingsIconComponent } from '@svg-icons/settings-icon/settings-icon.component';
import { DocumentIconComponent } from '@svg-icons/document-icon/document-icon.component';
import { RolesIconComponent } from '@svg-icons/roles-icon/roles-icon.component';
import { DataModelIconComponent } from '@svg-icons/data-model-icon/data-model-icon.component';
import { WorkflowIconComponent } from '@svg-icons/workflow-icon/workflow-icon.component';
import { IntegrationIconComponent } from '@svg-icons/integration-icon/integration-icon.component';
import { ActivityIconComponent } from '@svg-icons/activity-icon/activity-icon.component';
import { RtIconCpuChip01Component } from '@rt-icons/rt-icon-cpu-chip-01/rt-icon-cpu-chip-01.component';
import { RtIconTranslate01Component } from '@rt-icons/rt-icon-translate-01/rt-icon-translate-01.component';
import { RtIconStar06Component } from '@rt-icons/rt-icon-star-06/rt-icon-star-06.component';
import { RtIconPaletteComponent } from '@rt-icons/rt-icon-palette/rt-icon-palette.component';
import { RtIconDatabase03Component } from '@rt-icons/rt-icon-database-03/rt-icon-database-03.component';
import { RtIconFileCode01Component } from '@rt-icons/rt-icon-file-code-01/rt-icon-file-code-01.component';
import { RtIconDataflow04Component } from '@rt-icons/rt-icon-dataflow-04/rt-icon-dataflow-04.component';
import { RtIconSchemaManagementComponent } from '@rt-icons/rt-icon-schema-management/rt-icon-schema-management.component';
import { RtIconCloudComponent } from '@rt-icons/rt-icon-cloud/rt-icon-cloud.component';
import { RtIconSecurityComponent } from '@rt-icons/rt-icon-security/rt-icon-security.component';
import { RtIconEnvironmentsComponent } from '@rt-icons/rt-icon-environments/rt-icon-environments.component';
import { RtIconScales01Component } from '@rt-icons/rt-icon-scales-01/rt-icon-scales-01.component';
import { RtIconTableComponent } from '@rt-icons/rt-icon-table/rt-icon-table.component';
import { RtIconBarChartSquareUpComponent } from '@rt-icons/rt-icon-bar-chart-square-up/rt-icon-bar-chart-square-up.component';
import { RtIconZapFastComponent } from '@rt-icons/rt-icon-zap-fast/rt-icon-zap-fast.component';
import { RtIconLineChartUp02Component } from '@rt-icons/rt-icon-line-chart-up-02/rt-icon-line-chart-up-02.component';
import { RtIconGitBranch02Component } from '@rt-icons/rt-icon-git-branch-02/rt-icon-git-branch-02.component';
import { RtIconRocket02Component } from '@rt-icons/rt-icon-rocket-02/rt-icon-rocket-02.component';
import { RtIconCheckCircleComponent } from '@rt-icons/rt-icon-check-circle/rt-icon-check-circle.component';
import { PlusIconComponent } from '@svg-icons/plus-icon/plus-icon.component';
import { RtIconClockComponent } from '@rt-icons/rt-icon-clock/rt-icon-clock.component';

/**
 * Single source of truth for mapping a string icon key to its concrete SVG icon
 * component. Replaces the duplicated `ngSwitch` icon blocks across the build &
 * operate nav bars, dropdown menus and overview tiles so styling and the icon
 * set stay consistent everywhere.
 */
@Component({
  selector: 'app-nav-menu-icon',
  standalone: true,
  imports: [
    CommonModule,
    PageIconComponent,
    SettingsIconComponent,
    DocumentIconComponent,
    RolesIconComponent,
    DataModelIconComponent,
    WorkflowIconComponent,
    IntegrationIconComponent,
    ActivityIconComponent,
    RtIconCpuChip01Component,
    RtIconTranslate01Component,
    RtIconStar06Component,
    RtIconPaletteComponent,
    RtIconDatabase03Component,
    RtIconFileCode01Component,
    RtIconDataflow04Component,
    RtIconSchemaManagementComponent,
    RtIconCloudComponent,
    RtIconSecurityComponent,
    PlusIconComponent,
    RtIconClockComponent,
    RtIconEnvironmentsComponent,
    RtIconScales01Component,
    RtIconTableComponent,
    RtIconBarChartSquareUpComponent,
    RtIconZapFastComponent,
    RtIconLineChartUp02Component,
    RtIconGitBranch02Component,
    RtIconRocket02Component,
    RtIconCheckCircleComponent
  ],
  templateUrl: './nav-menu-icon.component.html',
  styleUrls: ['./nav-menu-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavMenuIconComponent {
  @Input() icon: string | undefined;
  @Input() size = 18;
}
